"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class ExtractServiceApi extends runtime.BaseAPI {
    /**
     * Cancel all executing Extract Commands for Object
     * CancelAllExtractCommands
     */
    extractServiceCancelAllExtractCommandsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.extractservice.v1.CancelAllExtractCommandsRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/extract/cancel-commands`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauExtractserviceV1CancelAllExtractCommandsRequestToJSON(requestParameters.tableauExtractserviceV1CancelAllExtractCommandsRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauExtractserviceV1CancelAllExtractCommandsResponseFromJSON(jsonValue));
        });
    }
    /**
     * Cancel all executing Extract Commands for Object
     * CancelAllExtractCommands
     */
    extractServiceCancelAllExtractCommands(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.extractServiceCancelAllExtractCommandsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Cancel an executing Extract Command
     * CancelExtractCommand
     */
    extractServiceCancelExtractCommandRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.extractservice.v1.CancelExtractCommandRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/extract/cancel-command`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauExtractserviceV1CancelExtractCommandRequestToJSON(requestParameters.tableauExtractserviceV1CancelExtractCommandRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauExtractserviceV1CancelExtractCommandResponseFromJSON(jsonValue));
        });
    }
    /**
     * Cancel an executing Extract Command
     * CancelExtractCommand
     */
    extractServiceCancelExtractCommand(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.extractServiceCancelExtractCommandRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Create Extract
     * CreateExtract
     */
    extractServiceCreateExtractRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.extractservice.v1.CreateExtractRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/extract/create-extract`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauExtractserviceV1CreateExtractRequestToJSON(requestParameters.tableauExtractserviceV1CreateExtractRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauExtractserviceV1CreateExtractResponseFromJSON(jsonValue));
        });
    }
    /**
     * Create Extract
     * CreateExtract
     */
    extractServiceCreateExtract(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.extractServiceCreateExtractRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get Extract Command Status
     * GetExtractCommandStatus
     */
    extractServiceGetCurrentExtractCommandStatusRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/extract/command_status`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauExtractserviceV1GetCurrentExtractCommandStatusResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get Extract Command Status
     * GetExtractCommandStatus
     */
    extractServiceGetCurrentExtractCommandStatus(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.extractServiceGetCurrentExtractCommandStatusRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get Extract Commands for Object
     * GetExtractCommands
     */
    extractServiceGetExtractCommandsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/extract/extract-commands`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauExtractserviceV1GetExtractCommandsResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get Extract Commands for Object
     * GetExtractCommands
     */
    extractServiceGetExtractCommands(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.extractServiceGetExtractCommandsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get Extract Connection Information
     * GetExtractConnection
     */
    extractServiceGetExtractConnectionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/extract/extract-connection`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauExtractserviceV1GetExtractConnectionResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get Extract Connection Information
     * GetExtractConnection
     */
    extractServiceGetExtractConnection(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.extractServiceGetExtractConnectionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get Sos Data Ids
     * GetSosDataIds
     */
    extractServiceGetSosDataIdsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/extract/sos-data-ids`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauExtractserviceV1GetSosDataIdsResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get Sos Data Ids
     * GetSosDataIds
     */
    extractServiceGetSosDataIds(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.extractServiceGetSosDataIdsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Refresh Extract Request
     * RefreshExtractRequest
     */
    extractServiceRefreshExtractRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.extractservice.v1.RefreshExtractRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/extract/refresh-extract`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauExtractserviceV1RefreshExtractRequestToJSON(requestParameters.tableauExtractserviceV1RefreshExtractRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauExtractserviceV1RefreshExtractResponseFromJSON(jsonValue));
        });
    }
    /**
     * Refresh Extract Request
     * RefreshExtractRequest
     */
    extractServiceRefreshExtract(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.extractServiceRefreshExtractRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Register Extractable Resource Object.
     * RegisterExtractableResourceObject
     */
    extractServiceRegisterExtractableResourceObjectRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.extractservice.v1.RegisterExtractableResourceObjectRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/extract/register-extractable-resource-object`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauExtractserviceV1RegisterExtractableResourceObjectRequestToJSON(requestParameters.tableauExtractserviceV1RegisterExtractableResourceObjectRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauExtractserviceV1RegisterExtractableResourceObjectResponseFromJSON(jsonValue));
        });
    }
    /**
     * Register Extractable Resource Object.
     * RegisterExtractableResourceObject
     */
    extractServiceRegisterExtractableResourceObject(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.extractServiceRegisterExtractableResourceObjectRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Unregister Extractable Resource Object.
     * UnregisterExtractableResourceObject
     */
    extractServiceUnregisterExtractableResourceObjectRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.extractservice.v1.UnregisterExtractableResourceObjectRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/extract/unregister-extractable-resource-object`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauExtractserviceV1UnregisterExtractableResourceObjectRequestToJSON(requestParameters.tableauExtractserviceV1UnregisterExtractableResourceObjectRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Unregister Extractable Resource Object.
     * UnregisterExtractableResourceObject
     */
    extractServiceUnregisterExtractableResourceObject(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.extractServiceUnregisterExtractableResourceObjectRaw(requestParameters);
        });
    }
}
exports.ExtractServiceApi = ExtractServiceApi;
